export default __webpack_public_path__ + "static/media/48-icon-share.8368b0ef.svg";